import React from "react";

const OverviewHeader = ({ kicker, title, lead }) => (
  <div className="overview-header">
    <p className="overview-kicker">{kicker}</p>
        <h2 className="overview-title" id="overview-title">{title}</h2>
    <p className="overview-lead">{lead}</p>
  </div>
);

export default OverviewHeader;
